/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type PhaseLifecycle =
  (typeof PhaseLifecycle)[keyof typeof PhaseLifecycle];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PhaseLifecycle = {
  ACTIVE: "ACTIVE",
  ON_HOLD: "ON_HOLD",
} as const;
